import { JSX, Show } from "solid-js";
import styles from "./Badge.module.css";

export type BadgeTone = "neutral" | "info" | "success" | "warning" | "error" | "accent";

interface BadgeProps {
  tone?: BadgeTone;
  icon?: string;
  children: JSX.Element;
  pill?: boolean;
  pulse?: boolean;
}

export function Badge(props: BadgeProps) {
  return (
    <span class={`${styles.badge} ${styles[props.tone ?? "neutral"]} ${props.pill ? styles.pill : ""}`}>
      <Show when={props.icon}>
        <i class={`fa-solid ${props.icon}`} aria-hidden="true" />
      </Show>
      <span>{props.children}</span>
    </span>
  );
}

interface StatusDotProps {
  tone?: BadgeTone;
  pulse?: boolean;
  size?: number;
}

export function StatusDot(props: StatusDotProps) {
  const size = () => props.size ?? 8;
  return (
    <span
      class={`${styles.dot} ${styles[`dot-${props.tone ?? "neutral"}`]} ${props.pulse ? styles.pulse : ""}`}
      style={{ width: `${size()}px`, height: `${size()}px` }}
      aria-hidden="true"
    />
  );
}
